import { render, staticRenderFns } from "./Menu.vue?vue&type=template&id=42c41845&scoped=true&"
var script = {}
import style0 from "./Menu.vue?vue&type=style&index=0&id=42c41845&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42c41845",
  null
  
)

export default component.exports